import { ScratchCard } from '../components/scratch/ScratchCard';

/** Player view of the scratch card — the realm's third draw. */
export function ScratchPage() {
  return <ScratchCard />;
}
